import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[lang]/(auth)/forgot-password/components/ForgotPassword.tsx");
